import { Action } from '@ngrx/store';
import { UserProfile } from '../model/user-profile.model';

export const LOAD_REQUEST = '[User Profile] Load Request';
export const LOAD_SUCCESS = '[User Profile] Load Success';
export const LOAD_ERROR =   '[User Profile] Load Error';

/**
 * Request to fetch user profile.
 */
export class LoadRequestAction implements Action {
    readonly type = LOAD_REQUEST;
}

/**
 * User profile successfuly fetched.
 */
export class LoadSuccessAction implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(public payload: UserProfile) {}
}

/**
 * Error when fetching user profile.
 */
export class LoadErrorAction implements Action {
    readonly type = LOAD_ERROR;

    constructor(public payload: any) { }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = LoadRequestAction
    | LoadSuccessAction
    | LoadErrorAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/actions/user-profile.actions.ts